export class CashRegisterPairVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  